export default __webpack_public_path__ + "static/media/img-b-result-distance.0fed597a.jpg";